import type { ChainConfig } from '../types'
import { getQuickNodeRpcUrl } from '../utils/getQuickNodeRpcUrl'

export const CELO = {
  name: 'celo',
  chainId: 42220,
  averageBlockTimeSeconds: 1,
  explorerUrl: 'https://celoscan.io',
  nativeAsset: {
    assetAddress: '0x471ece3750da237f93b8e339c536989b8978a438',
    decimals: 18,
    name: 'Celo native asset',
    symbol: 'CELO',
  },
  slip44: 52752,
  wrappedNativeAsset: '0x471ece3750da237f93b8e339c536989b8978a438',
  blockscoutApiUrl: 'https://celo.blockscout.com/api',
  etherscanSupported: true,
  publicRpcUrls: ['https://forno.celo.org', 'https://celo.drpc.org'],
  getPrivateRpcUrls: () => {
    const swell: string[] = []
    process.env.ROUTEME_API_KEY && swell.push(`https://lb.routeme.sh/rpc/42220/${process.env.ROUTEME_API_KEY}`)
    const quickNodeUrl = getQuickNodeRpcUrl('celo')
    quickNodeUrl && swell.push(quickNodeUrl)
    process.env.INFURA_API_KEY && swell.push(`https://celo-mainnet.infura.io/v3/${process.env.INFURA_API_KEY}`)
    process.env.ANKR_API_KEY && swell.push(`https://rpc.ankr.com/celo/${process.env.ANKR_API_KEY}`)
    return swell
  },
} as const satisfies ChainConfig
